const ImageType = Object.freeze({
  MATERIAL: 'MATERIAL',
  USER: 'USER',
  AI: 'AI',
  STOCK: 'STOCK',
})

export default ImageType
